import React, {
    useEffect,
    useState,
    useContext,
    useCallback,
    useMemo,
} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useMediaQuery } from 'react-responsive';

import ListVehicleCard from '../components/shared/vehicleCard/ListVehicleCard';
import ParseService from '../services/ParseService';
import { withCookies } from 'react-cookie';
import VehicleFilters from '../components/vehicleFilters/VehicleFilters';
import AdvancedFilters from '../components/vehicleFilters/AdvancedFilters';
import Button from '../components/bronson/Button';
import Select from '../components/bronson/Select';
import { withRouter } from 'react-router-dom';
import TagFilters from '../components/vehicleFilters/TagFilters';
import Traductor from '../components/Traductor';
import Loading from '../components/bronson/Loading';
import CustomMessage from '../components/shared/CustomMessage';
import ErrorModal from '../components/batches/Details/DetailsModal';
import { UserContext } from '../contexts/UserContext';

import VehicleService from '../services/VehicleService';
import ModalFirstBidPreferences from '../components/shared/ModalFirstBidPreferences';

import * as actions from '../redux/actions/batches';
import * as filtersActions from '../redux/actions/filters';
import * as vehiclesActions from '../redux/actions/auctions';
import { makeGetCountSelectedFilters } from '../redux/selectors/filters';
import useSocketListeners from 'hooks/useSocketListeners';
import useServerTime from 'hooks/useServerTime';

import {
    filterOrder,
    filterFavorite,
    filterAgrupations,
    filterBrands,
    filterModels,
    filterKm,
    filterZones,
    filterEnergies,
    filterPlate,
    filterPowerMax,
    filterPriceMax,
    filterRegistrationDate,
    filterVehiclesBid,
} from '../constants/Filters';
import '../css/pages/agrupation.css';
import Globals from '../Globals';
import ScrollToTop from '../components/ScrollToTop';
import { disableHTMLOverflow } from '../Functions';
import AWSSignal from '../components/AWSSignal';

import { READONLY_PERMISSION } from 'constants/Permissions';
import usePermissions from 'hooks/usePermissions';

const AuctionsPage = ({
    history,
    cookies,
    vehiclesInTrolley,
    batchError,
    clearErrors,
    filters,
    filtersOptions,
    setFilters,
    initialFilters,
    setInitialFilters,
    selectedFiltersCount,
    setVehiclesList,
    resetVehiclesList,
    vehiclesList,
}) => {
    const isMobileOrTablet = useMediaQuery({ maxWidth: 960 });
    const t = useMemo(() => new Traductor(), []);
    const { preferences } = useContext(UserContext);
    const { user } = useContext(UserContext);
    const [advancedFilters, setAdvancedFilters] = useState(false);
    const [loading, setLoading] = useState(true);
    const [renderLoading, setRenderLoading] = useState(true);
    const [lastNumberVehicles, setLastNumberVehicles] = useState(0);
    const { checkPermission } = usePermissions();
    const availableFilters = useMemo(
        () =>
            filters.upcomingAgrupation
                ? {
                      advanced: [
                          filterBrands,
                          filterModels,
                          filterKm,
                          filterEnergies,
                          filterZones,
                          filterPowerMax,
                          filterPriceMax,
                          filterRegistrationDate,
                          filterPlate,
                      ],
                      principal: [filterBrands, filterModels, filterKm],
                  }
                : {
                      advanced: [
                          filterFavorite,
                          filterAgrupations,
                          filterBrands,
                          filterModels,
                          filterKm,
                          filterEnergies,
                          filterZones,
                          filterPowerMax,
                          filterPriceMax,
                          filterRegistrationDate,
                          filterPlate,
                      ],
                      principal: [
                          filterFavorite,
                          filterAgrupations,
                          filterBrands,
                          filterModels,
                          filterKm,
                      ],
                  },
        [filters.upcomingAgrupation]
    );
    const { serverTime, fetchServerTime } = useServerTime(true);

    useSocketListeners();

    const phantomCall = useCallback(async () => {
        const bid = {
            IdVehicle: "0",
            Bid: "0",
            BidMax: "0",
            IdPreferenceTransport: "0",
            IdUser: cookies.get(Globals.COOKIES.USER),
            IdCustomer: "0",
        };
        const token = cookies.get(Globals.COOKIES.JWT);
        if (token) {
            await new VehicleService().insertBid(
                process.env.REACT_APP_AWS_BIDS_URL,
                process.env.REACT_APP_AWS_BIDS_APIKEY_NAME,
                process.env.REACT_APP_AWS_BIDS_APIKEY_VALUE,
                bid,
                token.AccessToken
            );
        }
    }, [cookies]);

    const getListAgrupatonsId = useCallback(
        () =>
            filtersOptions?.Agrupations
                ? filtersOptions.Agrupations.map(e => e.Id)
                : [],
        [filtersOptions.Agrupations]
    );

    const getFilters = useCallback(async () => {
        setRenderLoading(false);
        await new VehicleService()
            .getFilters(cookies.get(Globals.COOKIES.JWT)?.AccessToken)
            .then(response => {
                if (response?.statusCode === 200 && response?.body?.Result) {
                    let newFiltersOptions = new ParseService().Parse(
                        response.body.Result
                    );

                    newFiltersOptions = {
                        ...newFiltersOptions,
                        Plate: '',
                        Orders:
                            newFiltersOptions?.Orders?.reduce(
                                (acc, order, index) => [
                                    ...acc,
                                    {
                                        ...order,
                                        SelectId: index,
                                        DisplayName: t.getTraduction(
                                            order.FieldName + 'ASC'
                                        ),
                                        OrderType: 'ASC',
                                    },
                                    {
                                        ...order,
                                        SelectId: index + 10,
                                        DisplayName: t.getTraduction(
                                            order.FieldName + 'DESC'
                                        ),
                                        OrderType: 'DESC',
                                    },
                                ],
                                []
                            ) || [],
                    };

                    setInitialFilters({
                        options: { ...newFiltersOptions },
                        initial: {
                            [filterKm]:
                                newFiltersOptions.KmsMax /*Need to add the filter with proper keys*/,
                            [filterPowerMax]: newFiltersOptions.PowerMax,
                            [filterPriceMax]: newFiltersOptions.PriceMax,
                            [filterRegistrationDate]:
                                newFiltersOptions.RegistrationDate,
                        },
                    });

                    if (filters[filterAgrupations].length === 0) {
                        const agrupationsList = getListAgrupatonsId();
                        if (agrupationsList.length > 0) {
                            newFiltersOptions[
                                filterAgrupations
                            ] = agrupationsList;
                        }
                    }

                    const newSelectedFilters = {
                        ...filters,
                        [filterKm]: filters[filterKm].length
                            ? filters[filterKm]
                            : newFiltersOptions.KmsMax,
                        [filterPowerMax]: filters[filterKm].length
                            ? filters[filterPowerMax]
                            : newFiltersOptions.PowerMax,
                        [filterPriceMax]: filters[filterKm].length
                            ? filters[filterPriceMax]
                            : newFiltersOptions.PriceMax,
                        [filterRegistrationDate]: filters[filterKm].length
                            ? filters[filterRegistrationDate]
                            : newFiltersOptions.RegistrationDate,
                    };

                    if (history?.location?.state?.selectedBatchToAdd) {
                        newSelectedFilters.filterAgrupations = newFiltersOptions.Agrupations.reduce(
                            (acc, agrupation) => {
                                return agrupation.EndDate ===
                                    history?.location?.state?.selectedBatchToAdd
                                        ?.details?.EndDate
                                    ? [...acc, agrupation.Id]
                                    : acc;
                            },
                            []
                        );
                    }

                    setFilters(newSelectedFilters);
                }
                setLoading(false);
            });
    }, [
        cookies,
        setInitialFilters,
        filters,
        history?.location?.state?.selectedBatchToAdd,
        setFilters,
        t,
        getListAgrupatonsId,
    ]);

    useEffect(() => {
        phantomCall();
        const intervalId = setInterval(() => {
            phantomCall();
        }, 240000);

        return () => {
            clearInterval(intervalId);
        };
    }, []);

    useEffect(() => {
        if (preferences.PreferenceId > 0) disableHTMLOverflow(false);
    }, [preferences.PreferenceId]);

    const getBiddenVehicles = useCallback(async () => {
        const url = process.env.REACT_APP_AWS_BIDS_COUNT_BY_USER;
        const IdUser = cookies.get(process.env.REACT_APP_USER_ID).toUpperCase();
        const apikeyname = process.env.REACT_APP_AWS_BIDS_APIKEY_NAME;
        const apikeyvalue = process.env.REACT_APP_AWS_BIDS_APIKEY_VALUE;
        const bid = {
            IdUser: IdUser,
            IdGroups: getListAgrupatonsId(),
        };

        if (bid.IdGroups.length > 0) {
            return await new VehicleService().getBidsCount(
                url,
                apikeyname,
                apikeyvalue,
                bid,
                cookies.get(Globals.COOKIES.JWT)?.AccessToken
            );
        }
        return [];
    }, [cookies, getListAgrupatonsId]);

    const getListVehicles = useCallback(async () => {
        if (renderLoading) return;
        setLoading(true);
        //BACKEND NEEDS FILTERAGRUPATION WITH ALL AUCTIONS IN ORDER TO SHOW ALL VEHICLES
        const validatedFilters = filters.filterAgrupations.length
            ? { ...filters }
            : {
                  ...filters,
                  filterAgrupations: filtersOptions?.Agrupations
                      ? filtersOptions.Agrupations.map(e => e.Id)
                      : [],
              };

        if (filters.filterBidden) {
            //FETCH BIDDEN VEHICLES LIST AND PASS IT TO GET-VEHICLES INSIDE FILTERVEHICLESBID
            const vehiclesBid = (await getBiddenVehicles()) || [];
            validatedFilters[filterVehiclesBid] = vehiclesBid;
        }

        const response = await new VehicleService().getVehicleList(
            cookies.get(Globals.COOKIES.JWT)?.AccessToken,
            validatedFilters
        );
        if (response?.body) {
            const { TotalCount, Vehicles } = new ParseService().Parse(
                response.body.Result
            );
            if (Vehicles?.length) {
                setVehiclesList(Vehicles);
                setLastNumberVehicles(TotalCount);
                fetchServerTime();
            } else {
                setLastNumberVehicles(0);
                resetVehiclesList();
            }
        }
        setLoading(false);
    }, [
        filters,
        filtersOptions?.Agrupations,
        cookies,
        fetchServerTime,
        getBiddenVehicles,
        setVehiclesList,
        resetVehiclesList,
    ]);

    useEffect(() => {
        getListVehicles();
    }, [filters]);

    useEffect(() => {
        getFilters();
    }, []);

    const refreshFilters = useCallback(
        newFiltersOptions => {
            setFilters({
                ...newFiltersOptions,
                [filterOrder]: { ...filters[filterOrder], Page: 1 },
            });
        },
        [filters, setFilters]
    );

    const onAdvancedFiltersPress = useCallback(() => {
        setAdvancedFilters(currentStatus => !currentStatus);
    }, []);

    const resetFilters = useCallback(
        returnData => {
            setFilters({ ...initialFilters });
            if (returnData) {
                return initialFilters;
            }
        },
        [initialFilters, setFilters]
    );

    const printAdvancedFilters = useCallback(() => {
        if (!advancedFilters) return null;
        return (
            <AdvancedFilters
                refreshFilters={refreshFilters}
                filters={filters}
                filtersOptions={filtersOptions}
                updateFilters={setFilters}
                setInitialFilters={setInitialFilters}
                closeAdvancedFilters={onAdvancedFiltersPress}
                countSelectedFilters={selectedFiltersCount}
                resetFilters={resetFilters}
                availableFilters={availableFilters.advanced}
            />
        );
    }, [
        advancedFilters,
        refreshFilters,
        filters,
        filtersOptions,
        setFilters,
        setInitialFilters,
        onAdvancedFiltersPress,
        selectedFiltersCount,
        resetFilters,
        availableFilters.advanced,
    ]);

    const printPrincipalFilters = useCallback(() => {
        if (isMobileOrTablet) return null;
        return (
            <VehicleFilters
                refreshFilters={refreshFilters}
                updateFilters={setFilters}
                setInitialFilters={setInitialFilters}
                filters={filters}
                filtersOptions={filtersOptions}
                availableFilters={availableFilters.principal}
            />
        );
    }, [
        isMobileOrTablet,
        refreshFilters,
        setFilters,
        setInitialFilters,
        filters,
        filtersOptions,
        availableFilters.principal,
    ]);

    const printWithoutVehiclesMessage = useCallback(() => {
        if (loading || (!loading && vehiclesList.length > 0)) return null;

        const options = {
            title: t.getTraduction('WithoutVehicles_title'),
            body: t.getTraduction('WithoutVehicles_body'),
            icon: 'no-vehicles',
            primaryButton: {
                options: {
                    btnTypes: ['secondary'],
                    text: t.getTraduction('ResetFilters'),
                },
                onClick: resetFilters,
            },
        };

        return <CustomMessage options={options} />;
    }, [loading, vehiclesList.length, resetFilters, t]);

    const changeOrderVehicleList = useCallback(
        id => {
            if (id >= 0) {
                const order = filtersOptions.Orders.find(
                    o => o.SelectId === +id
                );
                if (order) {
                    order.Page = initialFilters.initPage;
                    order.Count = initialFilters.initCountVehicles;
                }
                setFilters({ ...filters, filterOrder: order });
            } else {
                setFilters({
                    ...filters,
                    filterOrder: {
                        SelectId: '',
                        FieldName: '',
                        OrderType: '',
                        Page: initialFilters.initPage,
                        Count: initialFilters.initCountVehicles,
                    },
                });
            }
        },
        [
            filters,
            filtersOptions?.Orders,
            initialFilters.initCountVehicles,
            initialFilters.initPage,
            setFilters,
        ]
    );

    const printErrors = useCallback(() => {
        return (
            <ErrorModal
                visible={batchError}
                onActionPress={() => {
                    const auctionsMatchingTrolley = filtersOptions?.Agrupations.reduce(
                        (acc, agrupation) => {
                            if (history?.location?.state?.selectedBatchToAdd) {
                                return agrupation.EndDate ===
                                    history.location.state.selectedBatchToAdd
                                        .details.EndDate
                                    ? [...acc, agrupation.Id]
                                    : acc;
                            } else {
                                return agrupation.EndDate ===
                                    vehiclesInTrolley[0].PublicationEndDate
                                    ? [...acc, agrupation.Id]
                                    : acc;
                            }
                        },
                        []
                    );
                    setFilters({
                        ...filters,
                        [filterAgrupations]: auctionsMatchingTrolley,
                    });
                    clearErrors();
                }}
                onClose={clearErrors}
                title={t.getTraduction('BatchErrorTitle')}
                content={batchError}
                leftButton={t.getTraduction('Close')}
                rightButton={t.getTraduction('SeeAvailable')}
            />
        );
    }, [
        batchError,
        clearErrors,
        t,
        filtersOptions?.Agrupations,
        setFilters,
        filters,
        history?.location?.state?.selectedBatchToAdd,
        vehiclesInTrolley,
    ]);

    const printMessageVehiclesNumber = useCallback(() => {
        let title = [];
        if (lastNumberVehicles === 0) {
            title.push(
                <div className="o-layout__item u-1/1" key={1}>
                    <p className="u-h1">
                        <span className="u-rema-weight-normal">
                            {t.getTraduction('NotFoundAnyVehicle')}
                        </span>
                    </p>
                </div>
            );
        } else {
            let auctionTitle = '';
            if (filtersOptions?.Agrupations && filters.upcomingAgrupation) {
                auctionTitle = filtersOptions?.Agrupations.find(
                    agrupation => agrupation.Id === filters.upcomingAgrupation
                )?.Description;
            }

            let lastCopy = '';
            if (
                vehiclesList.length > 1 ||
                (lastNumberVehicles > 1 && loading)
            ) {
                if (auctionTitle !== '') {
                    lastCopy = t.getTraduction('VehiclesFound');
                } else {
                    lastCopy = t.getTraduction('VehiclesForYou');
                }
            } else {
                if (auctionTitle !== '') {
                    lastCopy = t.getTraduction('VehicleFound');
                } else {
                    lastCopy = t.getTraduction('VehicleForYou');
                }
            }

            title.push(
                <div className="o-layout__item u-1/1" key={2}>
                    <p className="u-h1">
                        <span className="u-rema-weight-normal">
                            {auctionTitle === ''
                                ? t.getTraduction('WeFound')
                                : auctionTitle + ': '}
                        </span>
                        {' ' + lastNumberVehicles + ' '}
                        <span className="u-rema-weight-normal">{lastCopy}</span>
                    </p>
                </div>
            );
        }
        return title;
    }, [
        lastNumberVehicles,
        t,
        filtersOptions.Agrupations,
        filters.upcomingAgrupation,
        vehiclesList.length,
        loading,
    ]);

    const printAlertOrFilterButtons = useCallback(() => {
        if (!isMobileOrTablet) {
            return null;
            /* return <Button options={optionsCreateAlert} onClick={openCreateAlertModal}></Button> */
        } else {
            let optionsAdvancedFiltersMobile = {
                text:
                    t.getTraduction('Filters') +
                    ' ' +
                    (selectedFiltersCount > 0
                        ? '(' + selectedFiltersCount + ')'
                        : ''),
                class: 'c-btn--full',
            };
            return (
                <Button
                    options={optionsAdvancedFiltersMobile}
                    onClick={onAdvancedFiltersPress}
                />
            );
        }
    }, [isMobileOrTablet, onAdvancedFiltersPress, selectedFiltersCount, t]);

    const printAdvantedFiltersInDesktop = useCallback(() => {
        if (!isMobileOrTablet && Object.keys(filters).length > 0) {
            let optionsAdvancedFilters = {
                text:
                    t.getTraduction('AdvancedFilters') +
                    ' ' +
                    (selectedFiltersCount > 0
                        ? '(' + selectedFiltersCount + ')'
                        : ''),
                class: 'c-btn--full',
            };

            return (
                <div className="o-layout">
                    <div className="o-layout__item">
                        <Button
                            options={optionsAdvancedFilters}
                            onClick={onAdvancedFiltersPress}
                        />
                    </div>
                </div>
            );
        }
    }, [
        isMobileOrTablet,
        onAdvancedFiltersPress,
        filters,
        selectedFiltersCount,
        t,
    ]);

    const printTagFilters = useCallback(() => {
        return (
            <div id="TagFiltersList" className="o-layout__item u-8/12 u-1/1@m">
                <ul className="c-tag-list">
                    <TagFilters
                        /*refreshFilters={refreshFilters}*/
                        filters={filters}
                        filtersOptions={filtersOptions}
                        resetFilters={resetFilters}
                    />
                </ul>
            </div>
        );
    }, [filters, filtersOptions, resetFilters]);

    const printOrderFilter = useCallback(() => {
        let disabled = true;
        let listOrders = [
            {
                value: -1, //Value 0 is selectId Price Asc
                text: t.getTraduction('OrderBy'),
            },
        ];

        if (filtersOptions?.Orders?.length) {
            disabled = false;
            filtersOptions.Orders.map(element =>
                listOrders.push({
                    value: element.SelectId,
                    text: element.DisplayName,
                })
            );
        }

        const selectOrderOptions = {
            id: 'orderVehicles',
            name: 'orderVehicles',
            text: t.getTraduction('OrderBy'),
            className: '',
            disabled: disabled,
            values: listOrders,
            showLabel: false,
        };

        return (
            <Select
                value={`${filters.filterOrder.SelectId}`}
                onChange={changeOrderVehicleList}
                options={selectOrderOptions}
            />
        );
    }, [
        changeOrderVehicleList,
        filters.filterOrder.SelectId,
        filtersOptions?.Orders,
        t,
    ]);

    const changeCurrentPage = useCallback(
        page => {
            setFilters({
                ...filters,
                filterOrder: { ...filters[filterOrder], Page: page },
            });
        },
        [filters, setFilters]
    );

    const printFirstTimeModalPreferences = useCallback(() => {
        if (
            loading ||
            checkPermission(READONLY_PERMISSION) ||
            (preferences.PreferenceId &&
                preferences.PreferenceId > 0 &&
                user.data.Dealers &&
                user.data.Dealers.some(
                    dealer =>
                        dealer.CIF.toUpperCase() ===
                        preferences.CifBuyer.toUpperCase()
                ))
        )
            return null;
        return <ModalFirstBidPreferences history={history} />;
    }, [checkPermission, history, loading, preferences.PreferenceId]);

    return (
        <>
            <ScrollToTop />
            <AWSSignal />
            <section
                className="o-content-section u-pt-small u-rema-full-height"
                data-testid="auctionsPageTestId"
            >
                <div className="o-page-wrap o-page-wrap--xsmall">
                    <div className="o-layout">
                        {printMessageVehiclesNumber()}
                    </div>
                    <div className="o-layout u-mb u-mt">
                        {!isMobileOrTablet ? printTagFilters() : null}
                        <div className="o-layout__item u-1/12 u-1/2@m">
                            {printAlertOrFilterButtons()}
                        </div>
                        <div className="o-layout__item u-3/12 u-1/2@m">
                            {printOrderFilter()}
                        </div>
                        {isMobileOrTablet ? printTagFilters() : null}
                    </div>
                    <div className="o-layout">
                        <div className="o-layout__item u-1/5 u-3/12@l u-hide@m">
                            {printPrincipalFilters()}
                            {printAdvantedFiltersInDesktop()}
                        </div>
                        <div className="o-layout__item u-4/5 u-9/12@l u-1/1@m">
                            {printWithoutVehiclesMessage()}
                            <ListVehicleCard
                                vehicleList={vehiclesList}
                                isLoading={loading}
                                history={history}
                                parentCurrentPage={filters[filterOrder].Page}
                                changeParentCurrentPage={changeCurrentPage}
                                limitVehicles={initialFilters.initCountVehicles}
                                lastNumberVehicles={lastNumberVehicles}
                                options={{ typeCards: 'default' }}
                                serverTime={serverTime}
                                fetchServerTime={fetchServerTime}
                            />
                        </div>
                    </div>
                </div>
            </section>
            {printAdvancedFilters()}
            <Loading ariaBusy={loading} disableIcon={true} />
            {printFirstTimeModalPreferences()}
            {printErrors()}
        </>
    );
};

const makeMapStateToProps = () => {
    const mapStateToProps = (state, props) => {
        const getCountSelectedFilters = makeGetCountSelectedFilters(
            Globals.APPLICATION_PATH.AUCTION
        );

        return {
            vehiclesList: state.auctions.vehicles,
            selectedFiltersCount: getCountSelectedFilters(state, props),
            vehiclesInTrolley: state.carsBatch.cars,
            batchError: state.carsBatch.error,
            filters: state.filters[Globals.APPLICATION_PATH.AUCTION].selected,
            filtersOptions:
                state.filters[Globals.APPLICATION_PATH.AUCTION].options,
            initialFilters:
                state.filters[Globals.APPLICATION_PATH.AUCTION].initial,
        };
    };
    return mapStateToProps;
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    ...bindActionCreators(
        { ...actions, ...filtersActions, ...vehiclesActions },
        args => {
            //inject key with page route to actions
            return dispatch({
                ...args,
                route: Globals.APPLICATION_PATH.AUCTION,
            });
        }
    ),
});

export default withCookies(
    withRouter(connect(makeMapStateToProps, mapDispatchToProps)(AuctionsPage))
);
